export interface Query {
  q: string;
  mode: QueryMode;
}

export enum QueryMode {
  GLM = "glm",
  MONGO = "mongo",
}
